/**
 * Shared operational constants — packing units, selling modes, user_role map, dealers, account types.
 */
export const packing_unit = {
    "1" :"Litre",
    "2" :"kilogram",
    "3" :"Number"

}

export const selling_mode = {
    "1" : "Sold same as purchased",
    "2" : "Sold in loose quantities only",
    "3" : "Sold in same size as well as loose quantities"

}

export const user_role = {
"1" : "Owner",
"2" : "Manager",
"3" : "Customer Attendant",
"4" : "Accountant",
}

export const dealers = {
    "1":"IOC",
    "2":"HP",
    "3":"BP",
    "4":"RELIANCE",
    "5":"ESSAR",
}

export const account_type = {
    "1":"Current Account",
    "2":"Savings Account",
    "3":"OD Account",
}

/** Matches ps_op_* note / ps_ac_transcation_details.description varchar(255). */
export const VOUCHER_NOTE_MAX_LENGTH = 255;

/**
 * Config-wizard first path segments (mirrors backend config('constant.SCREEN')).
 * Owner/Manager may stay on these until pump meta stat_operation === "Yes".
 */
export const CONFIG_WIZARD_SCREENS = [
    "pump-details",
    "fuel-config",
    "tank-config",
    "nozzle-config",
    "fuel-config-report",
    "loose-oil-config",
    "Productsconfig",
    "products",
    "rack-config",
    "rack-product-list",
    "users",
    "customers",
    "creditor-debitor",
    "digital-payment",
    "bank-opening",
    "fleet-card-config",
    "MLA-coupon",
    "vendor-config",
    "dealership-config",
    "open-balance",
    "owntanker-config",
    "tanker-income",
    "tanker-expense",
    "other-income",
    "expenses",
    "task-config",
    "fuel-unloading",
    "config-report",
    "balance-sheet",
    "cbalance-sheet",
]

/** Extra paths allowed while Owner/Manager config is still incomplete. */
export const CONFIG_WIZARD_EXTRA_PATHS = [
    "logout",
    "subscription",
    "subscription-management",
    "payment-Success",
    "payment-Failed",
    "invoice-settings",
]

export function isOwnerOrManagerRole(roleName) {
    return roleName === "Owner" || roleName === "Manager"
}

export function isConfigWizardPath(pathname) {
    const segment = String(pathname || "/")
        .replace(/^\//, "")
        .split("/")[0]
    if (!segment) {
        return false
    }
    return (
        CONFIG_WIZARD_SCREENS.includes(segment) ||
        CONFIG_WIZARD_EXTRA_PATHS.includes(segment)
    )
}

/** Clamp stored last_screen to config-wizard routes (pre operational-date). */
export function clampConfigWizardResumeScreen(lastScreen) {
    const screen = String(lastScreen || "")
        .replace(/^\//, "")
        .split("/")[0]

    if (!screen) {
        return "pump-details"
    }
    if (CONFIG_WIZARD_SCREENS.includes(screen)) {
        return screen
    }
    return CONFIG_WIZARD_SCREENS.includes("cbalance-sheet")
        ? "cbalance-sheet"
        : "pump-details"
}

export function configWizardResumePath() {
    const resume = localStorage.getItem("LAST_SCREEN") || "pump-details"
    return `/${clampConfigWizardResumeScreen(resume)}`
}